import _app from '../../../server';

import React, { Component, Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { subscribe } from 'mqtt-react';
import { Container } from 'reactstrap';
import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarHeader,
  AppSidebarForm,
  AppSidebarFooter,
  AppSidebarMinimizer,
  AppSidebarNav,
  AppBreadcrumb
} from '@coreui/react';

import moment from 'moment';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Header, Footer } from 'components/sections';
import navigation from 'components/config/_nav';

import routes_pub from 'components/config/routes_pub';
import routes_pvt from 'components/config/routes_pvt';

import { mqtt_handlers } from 'redux/actions/mqtt';
import { auth__logout, auth__restoreLogon } from 'redux/actions/auth';


var loginTimeOut = null;

class PrivateLayout extends Component {

  componentWillMount() {
    //console.log("PrivateLayout ======componentWillMount======== :\n", this.props.mqtt)
    loginTimeOut = null;
  }
  componentWillUnmount() {
    this.props.mqtt.end();
    //console.log("PrivateLayout ======componentWillUnmount======== :\n", this.props.mqtt)
    clearTimeout(loginTimeOut);
  }

  render() {
    let routes = routes_pvt;
    if (this.props.authinfo.profile.email === _app.dashboard) {
      routes = routes_pub;
    }

    let storage = JSON.parse(localStorage.getItem("guardexpert_logon"));
    if (!this.props.isauthenticated && storage) {
      let ttl = storage.info.ttl;
      if (ttl > 0) {
        let from = moment(storage.info.created).valueOf();
        let until = moment(from).add(ttl, 'seconds').valueOf();
        let nowUnix = moment().valueOf();

        if (nowUnix > until) {
          this.props.dispatch(auth__logout());
          return null;
        }
      }
      this.props.dispatch(auth__restoreLogon(storage));
      return <div style={{ margin: '50px' }}><p>Loading ...</p></div>
    }

    if (this.props.isauthenticated) {
      if (storage && !loginTimeOut) {
        let ttl = storage.info.ttl;
        if (ttl > 0) {
          let from = moment(storage.info.created).valueOf();
          let until = moment(from).add(ttl, 'seconds').valueOf();
          let nowUnix = moment().valueOf();

          if (nowUnix > until) {
            this.props.dispatch(auth__logout());
            return null;
          }
          let timeOut = Math.round((until - nowUnix));

          //console.log("===============Seconds left==================:\n", Math.round(timeOut / 1000) - 60);
          clearTimeout(loginTimeOut);
          loginTimeOut = setTimeout(() => {
            //console.log("===============Logging Out==================:\n");
            this.props.dispatch(auth__logout());
          }, timeOut - 60000)
        }
      }

      return (
        <Fragment>
          <div className='app'>
            <AppHeader fixed>
              <Header mqtt={this.props.mqtt} {...this.props} />
            </AppHeader>
            <div className='app-body'>
              <AppSidebar fixed display='lg'>
                <AppSidebarHeader />
                <AppSidebarForm />
                <AppSidebarNav navConfig={navigation} {...this.props} />
                <AppSidebarFooter />
                <AppSidebarMinimizer />
              </AppSidebar>
              <main className='main'>
                <AppBreadcrumb className='ml-auto' appRoutes={routes} />
                <Container fluid className={this.props.location.pathname === '/dashboard' ? 'h-88' : ''}>
                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <route.component {...props} {...this.props} />
                          )}
                        />
                      ) : null;
                    })}
                    <Redirect from='/' to='/dashboard' />
                  </Switch>
                </Container>
              </main>
            </div>
            <AppFooter>
              <Footer />
            </AppFooter>
          </div>
        </Fragment>
      );
    } else {
      return <Redirect to='/login' />;
    }
  }
}

const mapStateToProps = store => {
  return {
    isauthenticated: store.auth.isAuth,
    authinfo: store.auth.info,
    userinfo: store.endusers.user
  };
};

PrivateLayout.propTypes = {
  location: PropTypes.object,
  isauthenticated: PropTypes.bool,
  authinfo: PropTypes.object,
  userinfo: PropTypes.object,
  dispatch: PropTypes.func,
  mqtt: PropTypes.object
};

export default compose(
  subscribe({
    topic: '#',
    dispatch: mqtt_handlers
  }),

  connect(mapStateToProps)
)(PrivateLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/PrivateLayout/PrivateLayout.js